<template>
  <div id="VGames" ref="VGames" style="max-width: 100%;">
    <router-view/>
    <div v-if="!hasShownAudioModal" class="overlay bring_in_front_all">
      <div class="a-vg-c--confirmation-modal pop-up">
        <div class="modal-head">
          {{$t('enable_audio_modal')}}
        </div>
        <div class="modal-body">
          <button class="a-vg-c--cta-button a-vg-c--cta-button__danger" @click="disableAudio()">
            {{$t('vdog_audio_no')}}
          </button>
          <button class="a-vg-c--cta-button a-vg-c--cta-button__success confirm" @click="enableAudio()">
            {{$t('vdog_audio_yes')}}
          </button>
        </div>
    </div>
    </div>
  </div>
</template>

<script>

import vuexStore from '../src/store/vuexStore'

export default {
  name: 'VGames',
  methods: {
    enableAudio () {
      vuexStore.dispatch('enableAudio')
    },
    disableAudio () {
      vuexStore.dispatch('disableAudio')
    }
  },
  data () {
    return {
      hasShownAudioModal: vuexStore.state.hasShownAudioModal
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasShownAudioModal,
      () => {
        this.hasShownAudioModal = vuexStore.state.hasShownAudioModal
      }
    )
  }
}
</script>
<style>
</style>
<style lang="scss">

  @import './assets/css/style.scss';

</style>
